// extracted by mini-css-extract-plugin
export var author = "signature-module--author--6784b";
export var signOff = "signature-module--signOff--59574";